import { NextSeo } from 'next-seo';
import { SubscriptionAndProfessionalServicesAgreementES } from '@/screens/Legal/SubscriptionAndProfessionalServicesAgreementES';

export default function SubscriptionAndProfessionalServicesAgreementESPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Contrato de Suscripción y Servicios Profesionales (Subscription and Professional Services Agreement) | Loadsmart"
        description="Contrato de Suscripción y Servicios Profesionales - Loadsmart"
        canonical="https://loadsmart.com/es/subscription-and-professional-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/es/subscription-and-professional-services-agreement/',
        }}
      />
      <SubscriptionAndProfessionalServicesAgreementES />
    </>
  );
}
